import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import { CHART_CARD_HEIGHT } from '@pages/audience/model/constant'
import Card from '@shared/ui/Card'

const LoadingCard = () => (
  <Box width="48%" mb={2}>
    <Card>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height={CHART_CARD_HEIGHT}
      >
        <CircularProgress />
      </Box>
    </Card>
  </Box>
)

export default LoadingCard
